import { compact } from 'lodash'
import { useSearchParams } from 'react-router-dom'
import { useLocationIntegrationStatus } from 'app/hooks/useLocationIntegrationStatus'

/**
 * The one location Agents → Availability shows, chosen in the URL. A `locationIds` selection carried
 * in from the header narrows the choices.
 */
export function useAvailabilityLocation() {
  const [searchParams, setSearchParams] = useSearchParams()
  const { locationOptions, isLoading } = useLocationIntegrationStatus([], `AI Agent`)
  const selectedIds = compact(searchParams.get(`locationIds`)?.split(`,`) ?? [])
  const choices = selectedIds.length
    ? locationOptions.filter((option) => selectedIds.includes(String(option.value)))
    : locationOptions
  const locationId =
    choices.find((option) => option.value === searchParams.get(`locationId`))?.value ?? choices[0]?.value
  const setLocationId = (value: string) =>
    setSearchParams(
      (prev) => {
        prev.set(`locationId`, value)
        return prev
      },
      { replace: true },
    )
  return { choices, locationId: locationId ? String(locationId) : undefined, isLoading, setLocationId }
}
